import styled, { css } from 'styled-components'

import { _XS_Bold, mainColors } from '@avantstay/backoffice-core'

export type AvatarVariant = 'guest' | 'teammate' | 'bot'

const variants = {
  guest: css`
    background: ${mainColors.primaryExtraLight};
    color: ${mainColors.primaryLight};
  `,
  teammate: css`
    background: ${mainColors.primaryMedium};
    color: ${mainColors.white};
  `,
  bot: css`
    background: ${mainColors.accentExtremelyLight};
    color: ${mainColors.accentDark};
  `,
}

export const Root = styled.span<{ $variant: AvatarVariant }>`
  ${_XS_Bold};
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex: none;
  ${({ $variant }) => variants[$variant]};
`

export const Slot = styled.span`
  width: 28px;
  flex: none;
`
